import {routes, useLivraisonsPossiblesContext} from 'ff-common';
import {useNavigate} from 'react-router-dom';
import {useNavigatePanier} from '../panier/useNavigatePanier';
import {useLivraisons} from '@/haligator-factory';
import {useHalStates} from '@synako/haligator';
import {useClientRoute} from '../auth/useClientRoute';

export const useAfficherPanier = () => {
  const {setLivraisonSelectionnee} = useLivraisonsPossiblesContext();
  const navigate = useNavigate();
  const navigatePanier = useNavigatePanier();
  const {buildClientRoute} = useClientRoute();
  const livraisonsPossibles = useHalStates(useLivraisons().followAll('items'));

  const afficherPanier = (dateLivraison: string) => {
    const livraisons = livraisonsPossibles.states?.filter(
      (livraison) => livraison.data.tolede.date_de_livraison === dateLivraison,
    );

    if (!livraisons || livraisons.length === 0) {
      console.warn('Aucune livraison trouvée pour', dateLivraison);
      navigate(buildClientRoute(routes.client.accueil));
      return;
    }

    // Priorité à la livraison qui a un panier ouvert
    let livraisonAvecPanier = livraisons.find((livraison) =>
      livraison.hasOneLink('panier_ouvert'),
    );

    // Si aucune livraison n'a de panier, prendre la première de la liste
    livraisonAvecPanier ??= livraisons[0];

    setLivraisonSelectionnee(livraisonAvecPanier);
    navigate(navigatePanier(dateLivraison));
  };

  return afficherPanier;
};
